import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Scroll from 'react-scroll';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Const from '../../util/Constants';
import PropertyController from '../../controller/PropertyController';
import PropertyAddEditInfo from './PropertyAddEditInfo';
import PropertyPricingInfo from './PropertyPricingInfo';
import PropertyAddressDetails from './PropertyAddressDetails';
import PropertyOwnerDetails from './PropertyOwnerDetails';
import PropertyOtherDetails from './PropertyOtherDetails';
import PropertyApiInfo from './PropertyApiInfo';
import PropertyAddEditCustom from './PropertyAddEditCustom';

import PropertyAPI from '../../api/PropertyAPI';

import ApiUiController from '../../controller/ApiUiController';
import ValidationController from '../../controller/ValidationController';

import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Calculate from '../../util/Calculate';
import DocumentAPI from '../../api/DocumentAPI';

class PropertyUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.propertyId);
    this.model = reactLocalStorage.getObject(Const.Model).property;
    this.property = PropertyController.addModel(this.model.fields);
    this.property.id = 0;
    this.state = { inApiCall: this.id !== 0, inValid: {} };
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
    this.docFormats = Const.FileType;
    if (!this.model.fields['contact~name']) {
      const opts = { visible: 1, editable: 1, form_mandate: 0 };
      this.model.fields['contact~name'] = { ...opts, field_type: 'text', label_name: 'Owner Name', validate: '' };
      this.model.fields['contact~phone'] = { ...opts, field_type: 'phone', label_name: 'Owner Phone', validate: '^[0,9]{8,13}' };
    }
  }

  componentDidMount() {
    if (this.id !== 0) {
      PropertyAPI.get(this.id, this.onReceived, this.failure, this.props.logout);
    }
  }

  failure = res => {
    Scroll.scroller.scrollTo(Object.keys(res)[0], { duration: 1500, smooth: true });
    const message = Util.failure(res);
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false, inValid: { ...res } });
  };

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.property);
    if (inValid === null) {
    this.setState({ ...this.state, inApiCall: true });
      PropertyAPI.saveProperty(this.property, this.onUpdateReceived, this.failure, this.props.logout);
      Util.showNotification('Successful', 'Property saved successfully', 'success');
    } else {
      const message = Util.failure(inValid);
      Util.showError(message);
      Scroll.scroller.scrollTo(Object.keys(inValid)[0], { duration: 1500, smooth: true });
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  };
  onReceived = property => {
    property['contact~name'] = property.cont_first;
    property['contact~phone'] = property.cont_phone;
    this.property = property;
    this.setState({ inApiCall: false });
  };
  onUpdateReceived = res => this.props.navigate(`${this.base}/preview/${res.id}`);

  onChange = (field, value) => {
    if (field == 'featured_image') {
      const document = {
        "id": 0,
        "file_type": 8,
        "description": "",
        "files": value,
        "model_no": 49,
        "model_id": this.property.id || 0,
        "link": ""
      };
      DocumentAPI.saveFeaturedImage(document,
        (files) => {
          this.property[field] = files;
          this.setState({ ...this.state });
        },
        (err) => {
          console.error('err', err);
        }
      );
    } else {
      this.property[field] = value;
      this.property = this.onChangeCalculate(-1, this.property, field);
    }
    this.setState({ ...this.state, inValid: {} });
  };

  onChangeCalculate = (index, sale, skipField) => {
    const keys = Object.keys(this.model.fields);
    let inner = [];
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (skipField !== key
        && key.includes(Const.T_Product) && key.includes(Const.Opt)
        && this.model.fields[key].calculate && this.model.fields[key].calculate !== '') {
        inner.push(key);
      }
    }

    inner = inner.sort((left, right) => {
      if (this.model.fields[left].field_order > this.model.fields[right].field_order) return 1;
      else if (this.model.fields[left].field_order < this.model.fields[right].field_order) return -1;
      else return 0;
    });

    if (index > -1) {
      for (let i = 0; i < inner.length; i++) {
        const field = inner[i];
        const type = this.model.fields[field].field_type;
        const fieldKeys = this.model.fields[field].field_key.split('~');

        if (type === Const.Discount || type === Const.Commission || type === Const.Tax) {
          const tmp = JSON.parse(this.model.fields[field].calculate);
          if (!sale.products[index][fieldKeys[1]]) {
            sale.products[index][fieldKeys[1]] = {};
          }
          if (tmp) {
            if (tmp.pre && tmp.pre.includes(skipField)) {
              sale.products[index][fieldKeys[1]][Const.TypePre] = Calculate.calculate(this.model.fields,
                index, sale, tmp.pre);
            }
            if (tmp.amount && tmp.amount.includes(skipField)) {
              sale.products[index][fieldKeys[1]][Const.TypeAmt] = Calculate.calculate(this.model.fields,
                index, sale, tmp.amount);
            }
          } else {
            sale.products[index][fieldKeys[1]][Const.TypePre] = 0;
            sale.products[index][fieldKeys[1]][Const.TypeAmt] = 0;
          }
        } else {
          const calculate = this.model.fields[field].calculate;
          if (calculate && calculate.includes(skipField)) {
            sale.products[index][fieldKeys[1]] = Calculate.calculate(this.model.fields, index, sale, calculate);
          }
        }
      }
    }
    inner = [];
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (skipField !== key
        && !key.includes(Const.T_Product) && !key.includes(Const.Opt)
        && this.model.fields[key].calculate && this.model.fields[key].calculate !== '') {
        inner.push(key);
      }
    }
    inner = inner.sort((left, right) => {
      if (this.model.fields[left].field_order > this.model.fields[right].field_order) return 1;
      else if (this.model.fields[left].field_order < this.model.fields[right].field_order) return -1;
      else return 0;
    });

    for (let i = 0; i < inner.length; i++) {
      const field = inner[i];
      const calculate = this.model.fields[field].calculate;
      if (calculate && calculate.includes(skipField)) {
        sale[field] = Calculate.calculate(this.model.fields, index, sale, calculate);
      }
    }
    return sale;
  };

  render() {
    return (
      <div className="sectionform">
        <div className="container form-cont">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <PropertyAddEditInfo model={this.model} property={this.property}
                onValueChange={this.onChange} inValid={this.state.inValid} />

              <PropertyPricingInfo model={this.model} property={this.property}
                onValueChange={this.onChange} inValid={this.state.inValid} />

              <PropertyAddressDetails model={this.model} property={this.property}
                onValueChange={this.onChange} inValid={this.state.inValid} />

              <PropertyOwnerDetails model={this.model} property={this.property}
                onValueChange={this.onChange} inValid={this.state.inValid} />

              <PropertyOtherDetails model={this.model} property={this.property}
                onValueChange={this.onChange} inValid={this.state.inValid} />

              <PropertyApiInfo model={this.model} property={this.property}
                onValueChange={this.onChange} inValid={this.state.inValid} />

              <PropertyAddEditCustom model={this.model} property={this.property}
                onValueChange={this.onChange} inValid={this.state.inValid} documentType={this.docFormats[0]} />

              <div className="col-md-12 text-center btnsend">
                <Button className="buttons btn-success" onClick={this.onSave}>
                  {this.id === 0 ? 'Save' : 'Update'} Property
                </Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(PropertyUpdate);